import React, { useState, useEffect } from 'react'
import {
  Panel,
  Modal,
  Row,
  Col,
  Uploader,
  Icon,
  Table,
  ButtonGroup,
  IconButton,
  Input,
  Button,
  Message,
  RadioGroup,
  Radio,
  ControlLabel,
  CheckboxGroup,
  Checkbox,
} from 'rsuite'
import { isValidators, isRequired } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../widgets/CustomIconMessageInfo'
import TooltipButton from '../../components/buttons/TooltipButton'
import classNames from 'classnames'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { API_ROOT } from '../../config/config'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import EditButton from '../../components/buttons/editButton/EditButton'
import AppContext from '../../context/AppContext'

export default function AttachFilesPDPAForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onUpdate = () => {},
  onDelete = () => {},
  onPreview = () => {},
  onDownload = () => {},
  onUploadError = () => {},
  onUploadSuccess = () => {},
  onValidateFile = () => {},
  disabledForm,
  isContract = false,
  ...props
}) {
  const { isEditErr, isUploadErr, isDeleteError, loading, disabledUpload, disabledEdit } = props
  const [formSchema, setFormSchema] = useState(schema)
  const [roleOfGrantreePDPAVal, setRoleOfGrantreePDPAVal] = useState('data_processor')
  const [attachmentFilePDPAVal, setAttachmentFilePDPAVal] = useState()
  const { Column, HeaderCell, Cell } = Table
  const [fileList, setFileList] = useState([])
  const [attachFiles, setAttachFiles] = useState([])
  const [selectEditeIndex, setSelectEditeIndex] = useState(-1)
  const [editName, setEditName] = useState()
  const [deleteIndex, setDeleteIndex] = useState()
  const [isAdd, setIsAdd] = useState(false)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isUploadError, setIsUploadError] = useState(false)
  const [isEditError, setIsEditError] = useState(false)
  const [isdelete, setIsdelete] = useState(false)
  const [deleteId, setDeleteId] = useState()
  const [fileTypeError, setFileTypeError] = useState(false)
  const [accessToken, setAccessToken] = useState()
  const [showConfirm, setShowConfirm] = useState(false)
  const [fileId, setFileId] = useState(false)
  const [rowDataItem, setRowDataItem] = useState(false)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [errorMsg, setErrorMsg] = useState({
    type: 'info',
    description: 'ชนิดที่รองรับ : .pdf ขนาดไฟล์ไม่เกิน 50 MB',
  })
  const { theme } = React.useContext(AppContext)

  useEffect(() => {
    setAttachFiles(formSchema.attachment.attachFiles.value || [])
  }, [schema.attachFiles])

  // useEffect(() => {
  //   console.log('diddidididididi')
  //   disabledForm = true
  // }, [])

  // const handlerChangeRoleOfGrantree = (value) => {
  //   // console.log('handlerChangeRoleOfGrantree ', value)
  //   setRoleOfGrantreePDPAVal(value)
  //   if (value == 'data_controller') {
  //     setAttachmentFilePDPAVal(['not_attach_documents'])
  //   } else {
  //     setAttachmentFilePDPAVal(['personal_data_processing_agreement_dpa'])
  //   }
  //   // roleType(value)
  // }

  const handlerChangeRoleOfGrantree = (value) => {
    console.log('handlerChangeRoleOfGrantree ', value)
    setRoleOfGrantreePDPAVal(value)
    if (value != 'data_controller') {
      setErrorMsg({
        type: 'info',
        description: 'ชนิดที่รองรับ : .pdf ขนาดไฟล์ไม่เกิน 50 MB',
      })
    } else {
      setErrorMsg({
        type: 'warning',
        description: 'ไม่ต้องแนบเอกสาร',
      })
    }
  }

  const handleUpload = (contractFileTypeId) => {
    return `${API_ROOT}/proposal/${projectId}/grantee/attachment/${contractFileTypeId}`
  }

  return (
    <>
      {formSchema?.inputForms?.roleOfGrantreePDPA && (
        <Row style={{ padding: '0px 30px 0px 30px' }}>
          <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: '10px' }}>
            <ControlLabel
              className={classNames(
                isRequired(formSchema?.inputForms?.roleOfGrantreePDPA?.validators) && 'required'
              )}
            >
              <b>{formSchema.inputForms?.roleOfGrantreePDPA.label}</b>
            </ControlLabel>
            <Controller
              key={formSchema.inputForms?.roleOfGrantreePDPA.name}
              name={formSchema.inputForms?.roleOfGrantreePDPA.name}
              control={control}
              render={(props) => {
                return (
                  <RadioGroup
                    name={formSchema.inputForms?.roleOfGrantreePDPA.name}
                    defaultValue={roleOfGrantreePDPAVal}
                    // defaultValue={formSchema.roleOfGrantreePDPA.value}
                    onChange={(value) => {
                      props.onChange(value)
                      handlerChangeRoleOfGrantree(value)
                    }}
                  >
                    {formSchema.inputForms?.roleOfGrantreePDPA.options?.map((item, index) => {
                      return (
                        <Radio
                          value={item.value}
                          disabled={formSchema.inputForms?.roleOfGrantreePDPA.disabled}
                          index={index}
                        >
                          {item.label}
                        </Radio>
                      )
                    })}
                  </RadioGroup>
                )
              }}
            />
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: '5%' }}>
            <Button color="blue" appearance="ghost">
              <Icon icon="info-circle" size="lg" /> {formSchema?.inputForms?.buttonText}
            </Button>
          </Col>
        </Row>
      )}
      {formSchema?.inputForms?.attachmentFilePDPA && (
        <Row style={{ padding: '0px 30px 0px 30px', marginTop: '20px' }}>
          <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
            <ControlLabel
              className={classNames(
                isRequired(formSchema.inputForms?.attachmentFilePDPA.validators) && 'required'
              )}
            >
              <b>{formSchema.inputForms?.attachmentFilePDPA.label}</b>
            </ControlLabel>
          </Col>
        </Row>
      )}
      {/* {formSchema?.inputForms?.attachmentFilePDPA && (
        <Row style={{ padding: '0px 30px 0px 30px', marginTop: '20px' }}>
          <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
            <ControlLabel
              className={classNames(
                isRequired(formSchema.inputForms?.attachmentFilePDPA.validators) && 'required'
              )}
            >
              <b>{formSchema.inputForms?.attachmentFilePDPA.label}</b>
            </ControlLabel>
            <ErrorMessage error={errors[formSchema?.inputForms?.attachmentFilePDPA.name]} />
            <Controller
              key={formSchema.inputForms?.attachmentFilePDPA.name}
              name={formSchema.inputForms?.attachmentFilePDPA.name}
              control={control}
              rules={isValidators(formSchema.inputForms?.attachmentFilePDPA.validators)}
              defaultValue={attachmentFilePDPAVal}
              render={(props) => {
                return (
                  <CheckboxGroup
                    value={attachmentFilePDPAVal}
                    onChange={(value) => {
                      // props.onChange(value)
                      if (value.length == 2) {
                        setAttachmentFilePDPAVal([value[1]])
                      } else {
                        setAttachmentFilePDPAVal(value)
                      }
                    }}
                  >
                    {formSchema.inputForms?.attachmentFilePDPA?.options?.map((item) => {
                      return (
                        <Checkbox
                          key={item.value}
                          value={item.value}
                          disabled={formSchema.inputForms?.attachmentFilePDPA.disabled}
                        >
                          {item.label}
                        </Checkbox>
                      )
                    })}
                  </CheckboxGroup>
                )
              }}
            />
          </Col>
        </Row>
      )} */}

      <Row style={{ padding: '0px 50px 0px 50px', marginTop: '20px' }}>
        {errorMsg && <Message showIcon type={errorMsg.type} description={errorMsg.description} />}
      </Row>

      {schema?.attachFiles?.description && (
        <Row style={{ padding: '0px 50px 0px 50px', marginTop: '10px' }}>
          <CustomIconMessageInfo contents={schema.attachFiles.description} />
        </Row>
      )}

      {roleOfGrantreePDPAVal != 'data_controller' && (
        <>
          <Row style={{ padding: '0px 50px 0px 50px', marginTop: '20px' }}>
            <Col
              lg={24}
              md={24}
              sm={24}
              xs={24}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <Controller
                name={'file'}
                control={control}
                defaultValue={undefined}
                render={(props) => {
                  return (
                    <Uploader
                      draggable
                      autoUpload={false}
                      multiple={true}
                      fileList={props.value || []}
                      onChange={(fileList) => {
                        if (isEmpty(fileList)) {
                          props.onChange(undefined)
                        } else {
                          // let files = []

                          // console.log('file ', fileList)

                          // files.push(fileList[fileList.length - 1])

                          props.onChange(fileList)
                        }
                      }}
                    >
                      <div>
                        <div
                          style={{ lineHeight: '50px' }}
                          className={classNames('uploader', `${theme[0]}-background`)}
                        >
                          <Icon size="4x" icon="upload2" />
                          <small className="uploder__text">
                            <p style={{ wordBreak: 'break-word' }}>
                              คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                            </p>
                          </small>
                        </div>
                      </div>
                    </Uploader>
                  )
                }}
              />
            </Col>
          </Row>

          <Row style={{ padding: '0px 50px 0px 50px', marginTop: '10px' }}>
            <Table autoHeight height={300} wordWrap bordered data={attachFiles}>
              <Column width={90} align="center" fixed>
                <HeaderCell>ไฟล์ที่</HeaderCell>
                <Cell>
                  {(_, index) => {
                    return index + 1
                  }}
                </Cell>
              </Column>

              <Column minWidth={150} flexGrow={1}>
                <HeaderCell>ประเภทไฟล์</HeaderCell>
                <Cell>
                  {(rowData) => {
                    //return validateEditFileName(rowData, index)
                    if (rowData.isRequired) {
                      return (
                        <span>
                          <span style={{ color: 'red' }}>*</span>
                          {rowData.fileType}
                        </span>
                      )
                    } else {
                      return rowData.fileType
                    }
                  }}
                </Cell>
              </Column>

              <Column minWidth={100} flexGrow={1}>
                <HeaderCell>ชื่อไฟล์</HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    //return validateEditFileName(rowData, index)
                    if (rowData.label) {
                      return rowData.label
                    } else {
                      return (
                        rowData.isRequired &&
                        !disabledForm && <span style={{ color: 'orange' }}>**กรุณาแนบไฟล์**</span>
                      )
                    }
                  }}
                </Cell>
              </Column>

              <Column width={130} align="center" fixed="right">
                <HeaderCell>แนบเอกสาร</HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    if (rowData.path) {
                      return (
                        <ButtonGroup>
                          <IconButton
                            appearance="ghost"
                            icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                            onClick={(e) => onPreview(rowData)}
                            disabled={loading}
                          />
                          <IconButton
                            appearance="ghost"
                            icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                            onClick={(e) => onDownload(rowData)}
                            disabled={loading}
                          />

                          {/* <IconButton
                      disabled={loading || selectEditeIndex == index}
                      icon={<Icon icon="pencil" />}
                      onClick={(e) => handleEditFile(rowData, index)}
                    /> */}
                          {!disabledForm && (
                            <IconButton
                              appearance="ghost"
                              className="rs-btn-ghost-cancel"
                              icon={
                                <Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />
                              }
                              onClick={(e) => handleDeleteFile(rowData, index)}
                              disabled={!rowData.enableDelete || rowData.isChecked}
                            />
                          )}
                        </ButtonGroup>
                      )
                    } else {
                      return (
                        !disabledForm && (
                          <>
                            {rowData.isLoading && <Loader backdrop center />}
                            <Uploader
                              style={rowData.isLoading ? { display: 'none' } : {}}
                              accept=".jpg, .jpeg, .png, .pdf"
                              headers={{ Authorization: `Bearer ${accessToken}` }}
                              multiple={false}
                              fileList={rowData.isLoading ? [] : rowData.fileList}
                              onChange={(fileList) => {
                                setRowData(rowData.id, {
                                  localFileList: fileList,
                                })
                              }}
                              onUpload={() => {
                                setRowData(rowData.id, {
                                  isLoading: true,
                                })
                              }}
                              onSuccess={(response) => {
                                setRowData(rowData.id, {
                                  fileLabel: response.label,
                                  fileName: response.name,
                                  filePath: response.path,
                                  isLoading: false,
                                  localFileList: [],
                                })
                                onUploadSuccess(response)
                              }}
                              onError={(e) => {
                                setRowData(rowData.id, {
                                  isLoading: false,
                                  localFileList: [],
                                })
                                onUploadError(e)
                                notification.open('error', {
                                  title: 'แนบเอกสารไม่สำเร็จ',
                                })
                              }}
                              listType="picture"
                              action={handleUpload(rowData.contractFileTypeId)}
                              name={isContract ? 'Files' : 'file'}
                              data={{
                                FileId: rowData.id || '',
                                MasterContractFileId: rowData.contractFileTypeId || '',
                                ProjectVersionId: projectId || '',
                              }}
                            >
                              <button className="upload__button" style={{ marginTop: 0 }}>
                                <Icon icon="upload" size="lg" />
                              </button>
                            </Uploader>
                          </>
                        )
                      )
                    }
                  }}
                </Cell>
              </Column>

              {/* {isStaff && !disabledForm && (
            <Column width={210} fixed="right">
              <HeaderCell></HeaderCell>
              <Cell style={{ marginRight: 20 }}>
                {(rowData) => {
                  if (rowData.path)
                    return (
                      <IconButton
                        icon={
                          <Icon
                            icon="check-circle"
                            style={{
                              color:
                                rowData.isChecked || rowData.isValidated ? '#14997a' : '#8e8e93',
                            }}
                          />
                        }
                        tooltip={`แสดง`}
                        onClick={(e) => handleOnClickCheckFile(rowData)}
                      >
                        บันทึกตรวจสอบไฟล์
                      </IconButton>
                    )
                }}
              </Cell>
            </Column>
          )} */}
            </Table>
          </Row>
        </>
      )}

      <hr />
      <SaveButton>บันทึกบทบาทของภาคีผู้รับทุน (PDPA)</SaveButton>

      {/* <EditButton>แก้ไขบทบาทของภาคีผู้รับทุน (PDPA)</EditButton> */}

      <br />
    </>
  )
}
